import { UserGroups } from "permissions/constants";

export var investorsRoutes = [
  // {
  //   to: "/",
  //   icon: "leaderboard",
  //   display_name: "Portfolio",
  //   notificationType: "InvestorDashboard",
  //   visibleTo: [UserGroups.Investor],
  // },
  {
    to: "/",
    icon: "insights",
    display_name: "See Deals",
    notificationType: "Contracts",
    visibleTo: [UserGroups.Investor],
  },
  // {
  //   to: "/listmydeals",
  //   icon: "view_stream",
  //   display_name: "List My Deals",
  //   notificationType: "Stakes",
  // },
];
export var adminRoutes = [
  {
    to: "/",
    icon: "store_mall_directory",
    display_name: "Startups",
    notificationType: "AdminStartups",
    visibleTo: [
      UserGroups.Manager,
      UserGroups.Partner,
      UserGroups.SuperAdmin,
      UserGroups.TopManagement,
    ],
  },
  {
    to: "/investors",
    icon: "attach_money",
    display_name: "Investors",
    notificationType: "AdminInvestors",
    visibleTo: [
      UserGroups.Manager,
      UserGroups.Partner,
      UserGroups.SuperAdmin,
      UserGroups.TopManagement,
    ],
  },
  {
    to: "/mailing",
    icon: "email",
    display_name: "Compose",
    notificationType: "Mail",
    visibleTo: [
      UserGroups.Manager,
      UserGroups.SuperAdmin,
      UserGroups.TopManagement,
    ],
  },
  {
    to: "/reports",
    icon: "description",
    display_name: "Reports",
    notificationType: "Reports",
    visibleTo: [
      UserGroups.Manager,
      UserGroups.SuperAdmin,
      UserGroups.TopManagement,
    ],
  },
  {
    to: "/task-runner",
    icon: "description",
    display_name: "Task Runner",
    visibleTo: [UserGroups.SuperAdmin, UserGroups.TopManagement],
  },
];
